export const NICHE_PILLAR_MAP: Record<string, { path: string; label: string; ctaCopy: string }> = {
  'stress-symptoms': {
    path: '/stress-physical-symptoms',
    label: 'Stress & Physical Symptoms',
    ctaCopy: 'Explore the full guide to stress & physical symptoms',
  },
  'medical-anxiety': {
    path: '/medical-anxiety-hypnotherapy',
    label: 'Medical Anxiety & Procedure Fears',
    ctaCopy: 'Explore the full guide to medical anxiety hypnotherapy',
  },
};
